import { Feeding, FeedingBaseRationGroup, OptimizedColor } from './feeding.types';

export const getFeedingPeriodBaseRationGroups = (feedings: Feeding[], feedingNo: number): FeedingBaseRationGroup[] => {
  /*** test data while BE not ready */
  // feedings = (feedings || []).map((item) =>
  //   item.id === 7247 || item.id === 4016
  //     ? {...item, baseRationId: 6693}
  //     : item,
  // );
  /* *********** */

  const baseRationIds = feedings.reduce((accum, value) => {
    const brId = value.baseRationId;
    return brId && !accum.includes(brId) ? [...accum, brId] : accum;
  }, [] as string[]);

  const feedingsIds = feedings.map((feeding) => feeding.id);

  return baseRationIds
    .filter((baseRationId) => {
      const baseFeeding = feedings.find((feeding) => feeding.rationId === baseRationId)!;
      return baseFeeding;
    })
    .map((baseRationId, index) => {
      const baseFeedings = feedings.filter((feeding) => feeding.rationId === baseRationId);
      return baseFeedings.map((baseFeeding) => {
        const feedingId = baseFeeding.id;
        const baseIndex = feedingsIds.findIndex((id) => id === feedingId);
        const feedingPlusIdsWithGroup = feedings
          .filter((feeding) => feeding.baseRationId === baseRationId)
          .map((item) => ({ feedingId: item.id, groupId: item.groupId, baseRationId: item.baseRationId }));
        const feedingPlusInfos = feedingPlusIdsWithGroup.map((feedingPlus) => {
          const itemIndex = feedingsIds.findIndex((id) => id === feedingPlus.feedingId);
          const optimized =
            itemIndex > baseIndex &&
            feedingsIds
              .slice(baseIndex + 1, itemIndex + 1)
              .filter((id) => {
                const baseRationFeeding = feedings.find((elem) => elem.id === id);
                const bsId = baseRationFeeding && baseRationFeeding.rationId;
                return !bsId || !baseFeeding.rationId ? true : bsId !== baseFeeding.rationId;
              })
              .every((id) => feedingPlusIdsWithGroup.find((item) => item.feedingId === id));
          return {
            feedingId: feedingPlus.feedingId,
            groupId: feedingPlus.groupId,
            optimized,
            baseIndex,
            itemIndex,
          };
        });
        const allOptimized = feedingPlusInfos.every((item) => item.optimized);
        const anyOptimized = feedingPlusInfos.some((item) => item.optimized);
        const baseFeedingInfo = {
          feedingId,
          groupId: baseFeeding.groupId,
          optimized: allOptimized,
          optimizedColor: allOptimized
            ? OptimizedColor.optimized
            : anyOptimized
            ? OptimizedColor.semiOptimized
            : OptimizedColor.notOptimized,
        };
        return {
          feedingNo,
          groupNumber: index + 1,
          baseRationId,
          feeding: baseFeedingInfo,
          feedingsPlus: feedingPlusInfos.map(({ feedingId: id, optimized, groupId, baseIndex, itemIndex }) => ({
            feedingId: id,
            groupId,
            optimized,
            baseIndex,
            itemIndex,
            optimizedColor: optimized
              ? allOptimized
                ? OptimizedColor.optimized
                : OptimizedColor.semiOptimized
              : OptimizedColor.notOptimized,
          })),
        };
      });
    })
    .reduce((elem, acc) => [...acc, ...elem], []);
};

export const GREEN = 'rgb(205, 252, 193)';
export const RED = 'rgb(243, 175, 172)';
export const YELLOW = 'rgb(254, 250, 177)';
